import { Layout } from "@/components/Layout";
import { useSettings } from "@/lib/settings";
import { buildWhatsAppLink } from "@/components/WhatsAppButton";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function Contact() {
  const settings = useSettings();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks! We'll be in touch shortly.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <Layout>
      <div className="border-b border-slate-200 bg-[#E3ECFB] py-16">
        <div className="container-x max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Get in Touch</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-slate-900 lg:text-5xl">Contact Us</h1>
          <p className="mt-4 text-lg text-slate-600">Our team is here to help with any question about our inventory or financing.</p>
        </div>
      </div>
      <div className="container-x py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div className="space-y-5">
            {settings && [
              [Phone, "Phone", settings.company_phone],
              [Mail, "Email", settings.company_email],
              [MapPin, "Address", settings.company_address],
            ].map(([Icon, t, v]) => (
              <div key={t} className="card-surface flex items-center gap-4 p-5">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold/10 text-gold"><Icon className="h-5 w-5" /></div>
                <div><div className="text-xs uppercase tracking-wider text-slate-500">{t}</div><div className="text-slate-900">{v}</div></div>
              </div>
            ))}
            {settings && (
              <a href={buildWhatsAppLink(settings.whatsapp_number, settings.whatsapp_message)} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn"
                className="flex items-center justify-center gap-2 rounded-xl bg-[#25D366] py-4 font-semibold text-white transition-transform hover:scale-[1.02]">
                <MessageCircle className="h-5 w-5" fill="white" /> Chat with F&amp;L Cars on WhatsApp
              </a>
            )}
          </div>
          <form onSubmit={submit} className="card-surface space-y-4 p-7">
            <div><label className="mb-1.5 block text-sm text-slate-700">Name</label><Input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border-slate-200 bg-[#EEF3FC] text-slate-900" /></div>
            <div><label className="mb-1.5 block text-sm text-slate-700">Email</label><Input data-testid="contact-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="border-slate-200 bg-[#EEF3FC] text-slate-900" /></div>
            <div><label className="mb-1.5 block text-sm text-slate-700">Message</label><Textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="border-slate-200 bg-[#EEF3FC] text-slate-900" /></div>
            <Button type="submit" data-testid="contact-submit" className="btn-gold w-full rounded-full py-6">Send Message</Button>
          </form>
        </div>
      </div>
    </Layout>
  );
}
